import { clearAllCaches } from './performance';

// Utility to handle chunk loading errors
export const handleChunkError = async (error) => {
  const isChunkError = error?.name === 'ChunkLoadError' || 
    error?.message?.includes('Loading chunk') ||
    error?.message?.includes('chunk');
    
  if (isChunkError) {
    console.warn('Chunk loading failed, clearing caches and reloading...', error);
    
    // Clear caches to ensure fresh resources
    try {
      await clearAllCaches();
    } catch (cacheError) {
      console.warn('Failed to clear caches:', cacheError);
    }
    
    // Small delay to prevent immediate reload loops
    setTimeout(() => {
      window.location.reload();
    }, 100);
    return true;
  }
  return false;
};

// Add global error handler for unhandled chunk errors
window.addEventListener('error', (event) => {
  if (handleChunkError(event.error)) {
    event.preventDefault();
  }
});

// Handle unhandled promise rejections (for dynamic imports)
window.addEventListener('unhandledrejection', (event) => {
  if (handleChunkError(event.reason)) {
    event.preventDefault();
  }
});